import { BaseEvent, BaseSender, RequestConfig } from '@fpkg/stats-core';
import { ajax } from '@fpkg/stats-utils/dist';

export default class WebSender extends BaseSender {
  preCollect: BaseEvent[] = [];

  /**
   * 设置神策实例，神策js异步加载成功时调用
   * @param sensors
   */
  handlerSensorsJsLoaded(sensors: any) {
    if (!sensors) return;

    this.sensors = sensors;

    // 注册公共参数
    this.sensors.registerPage && this.sensors.registerPage(this.commonParams);

    this.initSensors();

    // 上传preCollect中的事件
    this.preCollect.forEach((eventInfo) => {
      setTimeout(() => {
        // 不使用sendSensors的原因是避免无限循环调用
        const { event, ...params } = eventInfo;
        this.sensors.track && this.sensors.track(event, params);
      }, 10);
    });
  }

  request(reqConfig: RequestConfig): Promise<any> {
    return ajax(reqConfig);
  }

  /**
   * 上报到神策,如何神策实例为空，先保存到全局变量
   * @param event
   */
  sendSensors(eventInfo: BaseEvent) {
    if (!this.sensors) {
      this.preCollect.push(eventInfo);
      return;
    }

    const { event, ...params } = eventInfo;
    this.sensors && this.sensors.track && this.sensors.track(event, params);
  }
}
